// ------------ import internal dependencies ------------
import { instance } from "../instance";

/**
 * Handle user Data
 * @param data
 * @returns
 */
interface Request {
  title: string;
  firstName: string;
  lastName: string;
  facility: string;
  role: string;
  profile: string;
}
interface UpdatePassword {
  oldPassword: string;
  newPassword: string;
}
export const getUser = async (userId: string) => {
  return instance({
    method: "get",
    url: `/user/details?userId=${userId}`,
  });
};

export const getUserFacilities = async (userId: string) => {
  return instance({
    method: "get",
    url: `/facilities/user?userId=${userId}`,
  });
};

export const getAllUsers = async (
  userId: string,
  limit: any,
  offset: any,
  searchParam: string,
  facility: string,
  role: string
) => {
  let url: string = `/filter/users/list?userId=${userId}&queryLimit=${limit}&offset=${offset}`;
  if (searchParam?.length) url += `&searchParam=${searchParam}`;
  if (facility?.length) url += `&facility=${facility}`;
  if (role?.length) url += `&role=${role}`;
  if (!searchParam?.length && !role?.length && !facility?.length) {
    url = `/users/list?userId=${userId}&queryLimit=${limit}&offset=${offset}`;
  }
  return instance({
    method: "get",
    url,
  });
};

/**
 * Register new user data
 * @param data
 * @returns
 */
export const registerNewUser = async (data: Request) => {
  return instance({
    method: "post",
    url: "/user/register",
    data,
  });
};

export const updateUserDetails = async (data: Request) => {
  return instance({
    method: "put",
    url: "/user/update",
    data,
  });
};

export const changeUserPassword = async (data: UpdatePassword) => {
  return instance({
    method: "post",
    url: "/password/update",
    data,
  });
};

/**
 * Handle facility permission edit update
 * @param data
 * @returns
 */
export const updateFacility = async (data: any) => {
  return instance({
    method: "put",
    url: "/facility",
    data,
  });
};

/**
 * get single user details
 * @param id
 * @returns
 */
export const getUserDetails = async (id: string) => {
  return instance({
    method: "get",
    url: `/user/details?userId=${id}`,
  });
};

/* Handle upload user image
 * @param data
 */
export const uploadUserImage = async (data: any) => {
  return instance({
    method: "post",
    url: "/image",
    data,
  });
};

/**
 * Get logged in user image
 * @param userId
 * @returns
 */
export const getUserImage = async (userId: string) => {
  return instance({
    method: "get",
    url: `image?userId=${userId}`,
  });
};

/**
 * check that username is available
 * @param username
 * @returns
 *
 */
export const checkUsername = async (username: string) => {
  return instance({
    method: "get",
    url: `username/validate?username=${username}`,
  });
};

export const changeUserStatus = async (data: {
  userId: string;
  status: string;
}) => {
  const { userId, status } = data;
  return instance({
    method: "put",
    url: `/user/status`,
    data: { userId, status },
  });
};

export const logSupportTicket = async (data: any) => {
  return instance({
    method: "post",
    url: "tickets",
    data,
  });
};
